import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { TcsmStates } from '../../root/tcsm-model';
import { MyCpgMidYearEnrollment } from '../../pages/arc/features/new-hire-enrollment/member/models/member-coverage-model';
import { getPendingForApprovalForms } from '../ducks/mlps-api';
import { setMyCpgMidYearPendingForApprovalForms } from '../../pages/arc/features/new-hire-enrollment/slice/new-hire-enrollment-slices';


export function useGetMidYearPendingApproval() {
	const pendingForApprovalEnrollments = useSelector<TcsmStates, MyCpgMidYearEnrollment[]>(state => state.newHireEnrollmentState?.myCpgPendingForApprovalEnrollment);
	const dispatch = useDispatch();
	const guid = useSelector<TcsmStates, string>(state => state?.authenticatedState?.clientGuid);

	useEffect(() => {

		if (guid){
			dispatch(getPendingForApprovalForms(guid, (response) => {
				dispatch(setMyCpgMidYearPendingForApprovalForms(response?.data));
			}));
		}

	}, [guid]);

	return pendingForApprovalEnrollments;
}